export const PoolTypePolicy = ({

    FREE_POOL1: "FREE_POOL1",
    FREE_POOL2: "FREE_POOL2",
    SUPP_POOL1: "SUPP_POOL1",
    SUPP_POOL2: "SUPP_POOL2"
})